import React, { createContext, useContext } from 'react';
import { notification } from 'antd';
import closeIcon from '@icons/Icon_Close_7.svg';
import { useTranslation } from 'react-i18next';

// Context 생성
const NotificationContext = createContext();

// NotificationProvider 컴포넌트
export const NotificationProvider = ({ children }) => {
  const { t } = useTranslation('common');
  const [api, contextHolder] = notification.useNotification({
    stack: { threshold: 10 },
  });
  const duration = 3;

  const infoNoti = (description) => {
    api.open({
      message: null,
      description: (
        <p style={{ margin: 0, whiteSpace: 'nowrap' }}>{description}</p>
      ),
      placement: 'bottom',
      duration,
      className: 'info-noti',
      key: `${description}`,
      closeIcon: null,
      style: {
        width: 'auto',
        minWidth: '100px',
      },
    });
  };

  const alarmNoti = (title = '알림', description) => {
    api.open({
      message: title,
      description,
      placement: 'bottomRight',
      duration,
      className: 'notification',
      key: `${title}-${description}`,
      closeIcon: <img alt={t('imageAlt.close')} src={closeIcon} className="close-icon" />,
    });
  };

  return (
    <NotificationContext.Provider value={{ alarmNoti, infoNoti }}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

// useNotification 훅
export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useMessage must be used within a NotificationProvider');
  }
  return context;
};
